module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-BoldItalic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-BoldItalic.woff
// module id = 57
// module chunks = 8